'use client';
import React from 'react';
import styles from './modal-header.module.scss';

export interface IMfrmModalHeader {
  toggleModal(): void;
  headerTitle?: string;
}

export const ModalHeader: React.FC<IMfrmModalHeader> = ({
  headerTitle,
  toggleModal,
}) => {
  return (
    <header className={styles.wrapper}>
      <h4 id="modalHeaderTitle" tabIndex={0}>
        {headerTitle}
      </h4>
      <button onClick={toggleModal} aria-label="close button">
        <img
          src="/makeapayment/icons/common/cross-button.svg"
          alt="cross button"
          aria-hidden="true"
        />
      </button>
    </header>
  );
};
